export const camelToSnakeCase = (str) =>
  str.replace(/[A-Z0-9]/g, (ltr, idx) => (idx > 0 ? `_${ltr.toLowerCase()}` : ltr.toLowerCase()));

export const snakeToCamelCase = (str) => str.replace(/_([a-z0-9])/g, (_, ltr) => ltr.toUpperCase());

export const objectKeysSnakeToCamel = (obj) =>
  Object.fromEntries(
    Object.entries(obj ?? {}).map(([key, value]) => [snakeToCamelCase(key), value]),
  );

const isPlainObject = (value) => {
  return Object.prototype.toString.call(value) === "[object Object]";
};

export const objectFieldsCamelToSnakeCase = (object) => {
  if (!isPlainObject(object)) {
    return object;
  }
  return Object.fromEntries(
    Object.entries(object).map(([key, value]) => [
      camelToSnakeCase(key),
      isPlainObject(value) ? objectFieldsCamelToSnakeCase(value) : value,
    ]),
  );
};

export const stripHTMLTags = (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  return doc.body.textContent || "";
};

/**
 * Parse un code de niveau (storeyCodeValue) en nombre signé.
 * Number() est utilisé plutôt qu'un tri naturel localeCompare car ce dernier
 * ignore le signe "-" et classerait -10 après -2. Les niveaux non numériques
 * (ex. "RDC") sont renvoyés en fin de liste.
 */
const parseStoreyLevel = (value) => {
  const level = Number(value);
  return Number.isFinite(level) ? level : Number.POSITIVE_INFINITY;
};

const naturalLabelCompare = (a, b) =>
  String(a ?? "").localeCompare(String(b ?? ""), undefined, {
    numeric: true,
    sensitivity: "base",
  });

/**
 * Trie les zones par niveau (numérique, -2, -1, 0, 1, 2...) puis par label de
 * zone en ordre alphanumérique naturel ("Logement 2" avant "Logement 10").
 */
export const sortingZoneSpaceRules = (a, b) => {
  const levelA = parseStoreyLevel(a.aosItemData.storeyData?.storeyCodeValue);
  const levelB = parseStoreyLevel(b.aosItemData.storeyData?.storeyCodeValue);

  if (levelA !== levelB) return levelA - levelB;

  return naturalLabelCompare(a.aosItemData.label, b.aosItemData.label);
};

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export const chainFilters =
  (...filterFunctions) =>
  (item) => {
    return filterFunctions
      .map((filterFn) => filterFn(item))
      .every((filterFnResult) => filterFnResult === true);
  };
